(() => {
  const content = {
    energy:['Energy-saving support','Designed to support more efficient household electricity use and help reduce unnecessary energy waste.'],
    stability:['Voltage stability','The current Voltreya product description presents support for a steadier electrical environment.'],
    appliances:['Appliance support','The current store describes help protecting household appliances from over-voltage and power surges.']
  };
  const buttons = [...document.querySelectorAll('[data-benefit]')];
  const note = document.getElementById('benefit-note');
  buttons.forEach(button => button.addEventListener('click', () => {
    const wasOpen = button.getAttribute('aria-expanded') === 'true';
    buttons.forEach(item => item.setAttribute('aria-expanded','false'));
    note.hidden = wasOpen;
    if (!wasOpen) {
      const [title, copy] = content[button.dataset.benefit];
      note.replaceChildren();
      const label = document.createElement('small'); label.textContent = 'CURRENT PRODUCT CLAIM';
      const heading = document.createElement('strong'); heading.textContent = title;
      const body = document.createElement('p'); body.textContent = copy;
      note.append(label,heading,body);
      button.setAttribute('aria-expanded','true');
    }
  }));
  const pin = document.querySelector('[data-scene-pin]');
  const sceneNote = document.getElementById('scene-note');
  pin?.addEventListener('click', () => {
    const isOpen = pin.getAttribute('aria-expanded') === 'true';
    pin.setAttribute('aria-expanded',String(!isOpen));
    sceneNote.hidden = isOpen;
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    note.hidden = true;
    buttons.forEach(item => item.setAttribute('aria-expanded','false'));
    if (pin && sceneNote) { pin.setAttribute('aria-expanded','false'); sceneNote.hidden = true; }
  });
})();
